import { ChangeDetectionStrategy, Component, HostListener, inject } from '@angular/core';
import { Dialog } from '@angular/cdk/dialog';

import { ChrComponentsModule } from '@ciphr-design-system/angular';
import { FileExportStore } from '../state/file-export.store';
import { FileExportManagerComponent } from './file-export-manager/file-export-manager.component';
import { TranslocoDirective } from '@jsverse/transloco';
import { first } from 'rxjs';
import { Overlay } from '@angular/cdk/overlay';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  standalone: true,
  templateUrl: './file-export.component.html',
  styleUrls: ['./file-export.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ChrComponentsModule, TranslocoDirective],
})
export class FileExportComponent {
  private fileExportStore = inject(FileExportStore);

  private readonly dialog = inject(Dialog);
  private readonly overlay = inject(Overlay);
  private readonly breakpointObserver = inject(BreakpointObserver);

  readonly currentDownloadingFilesLength = this.fileExportStore.currentDownloadingFilesLength;

  @HostListener('window:beforeunload', ['$event'])
  beforeUnload(event: BeforeUnloadEvent) {
    this.currentDownloadingFilesLength() > 0 && event.preventDefault();
  }

  openFileExportManager(): void {
    const isHandset = this.breakpointObserver.isMatched(Breakpoints.Handset);
    const dialogRef = this.dialog.open(FileExportManagerComponent, {
      positionStrategy: isHandset ? this.overlay.position().global().bottom().centerHorizontally() : undefined,
      width: isHandset ? '100%' : 'auto',
    });
    dialogRef.closed.pipe(first()).subscribe(() => this.fileExportStore.clearCompletedFiles());
  }
}
